
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.667 14.667H14V10h-2V7.333H8.667V6h2V1.333H5.333V6h2v1.333H4V10H2v4.667h5.333V10h-2V8.667h5.334V10h-2v4.667zm-2-10v-2h2.666v2H6.667zM6 11.333v2H3.333v-2H6zm6.667 0v2H10v-2h2.667z","fill":"currentColor"}})])
          )
        }
      }
    